import * as React from 'react';
import { IAppState } from '../../common/classes/app';
import { Dispatch } from 'redux';
import * as moment from 'moment';
import { connect } from 'react-redux';
import axios from 'axios';
import { ISearchResultsDTO } from '../../common/classes/search-results-dto';
import { removeFilter, upsertFilter, NextMonth, PrevMonth, fetchEvents, EveryXWeek, NthDayOfMonth } from '../../common/redux-state/actions/filters';
import { IFilterState } from '../../common/redux-state/reducers/filters';



interface StateToProps {
    selectedDate: string
    currentMonth: moment.Moment
    monthWithEvent: moment.Moment[]
    everyXWeek: EveryXWeek[],
    nthDayOfMonth: NthDayOfMonth[]
}

interface DispatchToProps {

    upsertFilter: (query: string) => void
    NextMonth: () => void
    PrevMonth: () => void

}
interface CalendarState {
    today: moment.Moment
}

type CalendarProps = DispatchToProps & StateToProps

const DAYS_IN_WEEK: number = 7;
class CalendarFilter extends React.Component<CalendarProps, CalendarState > {

    constructor(props) {
        super(props)
        this.state = {

            today: moment()
        };
    }

    //update filter
    updateFilter(evt: React.ChangeEvent<HTMLLIElement>) {
        evt.preventDefault();
        let query = evt.target.value.toString();
        this.props.upsertFilter(query)
    }

    //update calendar state to next month
    nextMonth() {
        this.props.NextMonth()

        // this.fetchEvents()
    }

    //update calendar state to previous month
    previousMonth() {
        this.props.PrevMonth()

        // this.fetchEvents()
    }

    private isAnEventDay(day: moment.Moment): boolean {
        if (this.state.today.isAfter(day)) {
            return false;
        }
        let firstDayOfTheYear = day.clone().startOf('year');
        let dayOffSet = firstDayOfTheYear.day() - 1 < 0 ? 6 : firstDayOfTheYear.day() - 1;
        let adjustedDay = day.dayOfYear() + dayOffSet;
        let dayOfWeek = day.day();
        for (let exw of this.props.everyXWeek) {
            if (exw.everyx>1) {
                if (exw.weekday.indexOf(dayOfWeek.toString()) > -1) {
                    if (adjustedDay <= DAYS_IN_WEEK) {
                        return true;
                    }
                    let nthWeekOfYear = adjustedDay % DAYS_IN_WEEK == 0 ? Math.floor(adjustedDay / DAYS_IN_WEEK) : (Math.floor(adjustedDay / DAYS_IN_WEEK)) + 1;
                    let x = (nthWeekOfYear + exw.everyx-1) % ( exw.everyx);
                    if (x == 0) {
                        return true;
                    }
                }

            }
            else {
                //handles every occurence in the week
                if (exw.weekday.length > 0 && exw.weekday.indexOf(dayOfWeek.toString()) > -1) return true;
            }

        }
        for (let ndw of this.props.nthDayOfMonth) {
            if (ndw.day && ndw.nth) {
               
               
                //handle sunday special case..
                let nthDayOfMonth = day.date() % DAYS_IN_WEEK == 0 ? Math.floor(day.date() / DAYS_IN_WEEK) : (Math.floor(day.date() / DAYS_IN_WEEK)) + 1;
                if (ndw.day === day.day().toString() && nthDayOfMonth.toString() === ndw.nth) {
                    return true;
                }
            }
        }
        return false;
    }

    renderButton(day: moment.Moment) {
        const dateFormat = "YYYY-MM-DD";

        if (day.isAfter(this.props.currentMonth, 'month')) {
            
            return (
                this.props.monthWithEvent.filter(eventDate => eventDate.isSame(day, 'day')).length > 0 || this.isAnEventDay(day)?
                    <button className="adage-calendar-day month-next" data-has-event="true" key={day.format("MMM Do")} value={day.format(dateFormat)} onClick={this.nextMonth.bind(this)}>{day.format("D")}</button> :
                    <button className="adage-calendar-day month-next" data-has-event="false" key={day.format("MMM Do")} value={day.format(dateFormat)} onClick={this.nextMonth.bind(this)}>{day.format("D")}</button>
            )
        }

        if (day.isBefore(this.props.currentMonth, 'month')) {
            return (
                this.props.monthWithEvent.filter(eventDate => eventDate.isSame(day, 'day')).length > 0 || this.isAnEventDay(day)?
                    <button className="adage-calendar-day month-prev" data-has-event="true" key={day.format("MMM Do")} value={day.format(dateFormat)} onClick={this.previousMonth.bind(this)}>{day.format("D")}</button> :
                    <button className="adage-calendar-day month-prev" data-has-event="false" key={day.format("MMM Do")} value={day.format(dateFormat)} onClick={this.previousMonth.bind(this)}>{day.format("D")}</button>
            )
        }

        return (
            this.props.monthWithEvent.filter(eventDate => eventDate.isSame(day, 'day')).length > 0 || this.isAnEventDay(day)?
                <button className={this.props.selectedDate === day.format(dateFormat) ? "adage-calendar-day active" : "adage-calendar-day"} data-has-event="true" key={day.format("MMM Do")} value={day.format(dateFormat)} onClick={this.updateFilter.bind(this)}>{day.format("D")}</button> :
                <button className={this.props.selectedDate === day.format(dateFormat) ? "adage-calendar-day active" : "adage-calendar-day"} data-has-event="false" key={day.format("MMM Do")} value={day.format(dateFormat)} onClick={this.updateFilter.bind(this)}>{day.format("D")}</button>
        )
    }

    render() {

        //construct the calendar data render a view
        let calendar = [];
        const startDay = this.props.currentMonth.clone().startOf('month').startOf('week');
        const endDay = this.props.currentMonth.clone().endOf('month').endOf('week');

        let date = startDay.clone();

        while (!date.isAfter(endDay, 'day')) {
            let week = [];
            let endWeek = date.clone().endOf('week');
            while (!date.isAfter(endWeek)) {
                let day = date.clone();
                week.push(day)
                date.add(1, 'day');
            }
            calendar.push(week);
        }

        return (
            <div className="adage-search-facet">

                <div className="adage-calendar-mini">

                    <div className="adage-calendar-controls">
                        <button className="btn btn-chevron btn-chevron-left" onClick={this.previousMonth.bind(this)}>
                            <svg className="svg-icon" aria-hidden="true" focusable="false">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-left" />
                            </svg>
                            <span className="visually-hidden">Go to previous Month</span>
                        </button>

                        <div className="adage-calendar-controls-month">{this.props.currentMonth.format("MMMM")}</div>

                        <button className="btn btn-chevron btn-chevron-right" onClick={this.nextMonth.bind(this)} >
                            <svg className="svg-icon" aria-hidden="true" focusable="false">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-right" />
                            </svg>
                            <span className="visually-hidden">Go to Next Month</span>
                        </button>
                    </div>

                    <div className="adage-calendar-grid">
                        {
                            calendar.map((week, id) =>
                                <div className="adage-calendar-grid-week" key={id}>
                                    {
                                        week.map(day => this.renderButton(day))
                                    }
                                </div>
                            )

                            //calendar.map((week, id) => week.map(day => this.renderButton(day)))
                        }
                    </div>
                </div>
            </div>
        )
    }
}
export function mapStateToProps(state: IAppState): StateToProps {
    if (state.filtersState.filters['specificdate'] === '') {
        return {
            selectedDate: '',
            currentMonth: state.filtersState.currentMonth,
            monthWithEvent: state.filtersState.monthWithEvent,
            everyXWeek: state.filtersState.everyXWeek,
            nthDayOfMonth: state.filtersState.nthDayOfMonth
        }
    } else {

        return {
            selectedDate: state.filtersState.filters['specificdate'],
            currentMonth: state.filtersState.currentMonth,
            monthWithEvent: state.filtersState.monthWithEvent,
            everyXWeek: state.filtersState.everyXWeek,
            nthDayOfMonth: state.filtersState.nthDayOfMonth
        }
    }
}

export function mapDispatchToProps(dispatch: Dispatch): DispatchToProps {

    return {
        upsertFilter: (query: string) => {
            if (!query || query === "") {
                dispatch(removeFilter('specificdate'));
            } else {
                dispatch(upsertFilter('specificdate', query) as any)
            }
        },
        NextMonth: () => { dispatch(NextMonth()) },
        PrevMonth: () => { dispatch(PrevMonth()) },


    }

}

export const ConnectedCalendarFilter = connect(mapStateToProps, mapDispatchToProps)(CalendarFilter);